import React, { useState } from "react";
import { Box, Button, Snackbar, Alert } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Title from "../components/header/Title";
import ShopTable from "../components/shop/ShopTable";
import ShopFormDialog from "../components/shop/ShopFormDialog";

const Shop: React.FC = () => {
  const [formOpen, setFormOpen] = useState(false);
  const [editingShopId, setEditingShopId] = useState<number | null>(null);
  const [reloadToken, setReloadToken] = useState(0);
  const [snackbar, setSnackbar] = useState<{ open: boolean; message: string; severity: "success" | "error" }>({
    open: false,
    message: "",
    severity: "success",
  });

  const openCreate = () => {
    setEditingShopId(null);
    setFormOpen(true);
  };

  const openEdit = (shopId: number) => {
    setEditingShopId(shopId);
    setFormOpen(true);
  };

  return (
    <React.Fragment>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Title title="Shops" subtitle="Managing the Shops" />
        <Box>
          <Button
            variant="contained"
            onClick={openCreate}
            sx={{ fontSize: "14px", padding: "10px 12px" }}
          >
            <AddIcon sx={{ mr: "4px" }} />
            Add New
          </Button>
        </Box>
      </Box>

      <ShopTable onEdit={openEdit} reloadToken={reloadToken} />

      <ShopFormDialog
        open={formOpen}
        shopId={editingShopId}
        onClose={() => setFormOpen(false)}
        onSaved={() => setReloadToken((t) => t + 1)}
        onSuccess={(message) => setSnackbar({ open: true, message, severity: "success" })}
        onError={(message) => setSnackbar({ open: true, message, severity: "error" })}
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
      >
        <Alert severity={snackbar.severity} onClose={() => setSnackbar((s) => ({ ...s, open: false }))}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
};

export default Shop;
